export var DialogEventNames;
(function (DialogEventNames) {
    DialogEventNames["UpgradeToTrialDialogBusinessEmail"] = "upgradeToTrialDialogBusinessEmail";
    DialogEventNames["UpgradeToTrialDialogPersonalEmail"] = "upgradeToTrialDialogPersonalEmail";
})(DialogEventNames || (DialogEventNames = {}));
